import React, { useRef, useState } from "react";
import Cropper, { ReactCropperElement } from "react-cropper";
import "cropperjs/dist/cropper.css";
import { Form, Input, Modal, Select } from "@arco-design/web-react";
import FormItem from "@arco-design/web-react/es/Form/form-item";
import Resolution from "@/pages/CreationSpace/CreativeSpace/CreativeContainer/components/Engineering/Resolution/Resolution";
import { debounce } from "lodash";
interface CropperInstance {
  getCroppedCanvas: () => HTMLCanvasElement;
}

const CropperDemo = (props) => {
  const { url, onCancel, visible, onOk } = props;
  const [cropperUrl, setCropperUrl] = useState("");
  const cropperRef = useRef<ReactCropperElement>(null);

  const onCrop = debounce(() => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      setCropperUrl(cropper.getCroppedCanvas()?.toDataURL());
    }
  }, 1000);

  return (
    <div>
      <Modal
        visible={visible}
        onOk={() => {
          const cropper = cropperRef.current?.cropper;
          const url = cropper?.getCroppedCanvas()?.toDataURL();
          onOk(url);
        }}
        title={"图片裁剪"}
        onCancel={() => {
          onCancel();
        }}
        autoFocus={false}
        focusLock={true}
        unmountOnExit={true}
        className={`vl-modal`}
      >
        <Cropper
          viewMode={1}
          src={url}
          style={{ height: 400, width: "100%" }}
          aspectRatio={1}
          guides={false}
          crop={() => {
            onCrop();
          }}
          ref={cropperRef}
        />
      </Modal>
    </div>
  );
};

export default CropperDemo;
